import styled from "styled-components";

export const StyledNoResults = styled.h2`
  text-align: center;
  margin: 50px 0;
`;